import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../utils/motion';
const modules = [{
  name: 'CJI Core',
  desc: 'Foundational reasoning and judgment assessment.'
}, {
  name: 'NCJI Youth',
  desc: 'Developmental support for early education.'
}, {
  name: 'NCJI Pathways',
  desc: 'Workforce readiness and opportunity alignment.'
}, {
  name: 'NCJI Civic',
  desc: 'Community resilience and manipulation resistance.'
}, {
  name: 'NCJI Service',
  desc: 'Integrity and systems reasoning for the public sector.'
}, {
  name: 'NCJI Executive',
  desc: 'Crisis reasoning and governance readiness.'
}, {
  name: 'NCJI Atlas',
  desc: 'Aggregate capability mapping for institutions.'
}];
export function ProductEcosystem() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-1198" data-mp="2wmudy53060up">
      <div className="mb-12" data-id="element-1199" data-mp="30o5uzm7t9dra">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-1200" data-mp="30nebh9rhn6hd">
          Assessment &amp; Development Modules
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-1201" data-mp="ynwgfz0hq4pu">
          The Human Capability Platform
        </h2>
        <p className="mt-4 text-lg text-ink-muted leading-relaxed max-w-3xl" data-id="element-1202" data-mp="tns2afn21m2s">
          Proposed modules within the CJI and NCJI frameworks. Each would
          require validation for its intended use before consequential
          application.
        </p>
      </div>

      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-1203" data-mp="fxokc0v7kej5">
        {modules.map(module => <li key={module.name} className="bg-surface-card p-6 rounded-lg border border-line flex flex-col h-full" data-id="element-1204" data-mp="azdahq4wy40x">
            <h3 className="text-lg font-heading font-bold text-navy mb-2" data-id="element-1205" data-mp="60tpbry58w9m">{module.name}</h3>
            <p className="text-sm text-ink-muted" data-id="element-1206" data-mp="1wc7hybcgt1h">{module.desc}</p>
          </li>)}
      </ul>

      <motion.div {...fadeUp} className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-line pt-12" data-id="element-1207" data-mp="3t4gk9o5tr47o">
        <div className="lg:col-span-5" data-id="element-1208" data-mp="3nho4ran0p1q0">
          <p className="text-sm font-medium text-teal mb-2" data-id="element-1209" data-mp="3niphdjjolw9u">Noetivra · Coming soon</p>
          <h3 className="font-heading font-bold text-2xl lg:text-3xl text-ink-dark leading-tight" data-id="element-1210" data-mp="39iy45l0zojww">
            Use the framework through Noetivra
          </h3>
        </div>
        <div className="lg:col-span-7" data-id="element-1211" data-mp="61oftobuhggn">
          <p className="text-lg text-ink-dark leading-relaxed mb-6" data-id="element-1212" data-mp="62r37m9yl0rt">
            Noetivra’s Human Capability Edition would provide the interactive
            workspace for completing tasks, reviewing findings, exploring
            development activities, and following progress over time. SKP would
            maintain the approved definitions, research, and versioned assessment
            knowledge behind that work.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-2" data-id="element-1213" data-mp="oyh5zbppu16r">
            <a href="/noetivra#human-capability-edition" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1214" data-mp="trsgbmtql03f">
              Human Capability Edition
              <ArrowRight size={16} aria-hidden="true" data-id="element-1215" data-mp="2n9zhiy748qr7" />
            </a>
            <a href="/semantic-knowledge" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1216" data-mp="2j84ftsl9wbcw">
              Semantic Knowledge Platform
              <ArrowRight size={16} aria-hidden="true" data-id="element-1217" data-mp="1qlbep93z1a2d" />
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}